var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

import React, { useState, useCallback } from 'react';

import { Calendar } from 'react-date-range';

import 'react-date-range/dist/styles.css'; // main style file
import 'react-date-range/dist/theme/default.css'; // theme css file

import PropTypes from 'prop-types';

var DatePicker = function DatePicker(_ref) {
    var onSubmit = _ref.onSubmit,
        props = _ref.props,
        footerComponents = _ref.footerComponents;

    var _useState = useState(new Date()),
        selectedDate = _useState[0],
        setSelectedDate = _useState[1];

    var handleSelect = useCallback(function (date) {
        setSelectedDate(date);
    }, [setSelectedDate]);

    var onClickDone = useCallback(function (e) {
        e.stopPropagation();
        e.preventDefault();
        onSubmit(selectedDate);
    }, [onSubmit, selectedDate]);

    var onClickClear = useCallback(function (e) {
        e.stopPropagation();
        e.preventDefault();
        setSelectedDate(new Date());
        onSubmit("");
    }, [setSelectedDate]);

    return React.createElement(
        'div',
        { className: 'shadow d-inline-block text-center' },
        React.createElement(Calendar, _extends({
            date: selectedDate,
            onChange: handleSelect
        }, props)),
        React.createElement(
            'div',
            { className: 'text-right mt-2 p-2' },
            React.createElement(
                'button',
                { className: 'btn btn-transparent text-primary mr-2', onClick: onClickDone },
                'Done'
            ),
            React.createElement(
                'button',
                { className: 'btn btn-transparent text-danger mr-2', onClick: onClickClear },
                'Clear'
            ),
            footerComponents
        )
    );
};

DatePicker.defaultProps = {
    onSubmit: function onSubmit(date) {}
};

DatePicker.propTypes = process.env.NODE_ENV !== "production" ? {
    /**
     * On Submit
     */
    onSubmit: PropTypes.func.isRequired,
    /**
     * Footer components
     */
    footerComponents: PropTypes.node
} : {};

export default DatePicker;